import React from 'react';
import { Helmet } from 'react-helmet';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import Section5 from './Section5';
import Section6 from './Section6';
import Section7 from './Section7';
import Section8 from './Section8';
import Section9 from './Section9';
import Section10 from './Section10';
import Section11 from './Section11';
import Section12 from './Section12';
import Section13 from './Section13';
import Section14 from './Section14';

export default function ShopifyPlus() {
  return (
    <div className="ShopifyPlus pt-[160px] sm:pt-0">
      <Helmet>
        <title>Best Shopify Plus Development Agency in Dubai | Mean3</title>
        <meta
          name="description"
          content="Mean3 is a trusted Shopify Plus agency in Dubai offering expert services, custom websites, and scalable Shopify Plus development for your business."
        />
      </Helmet>

      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section11 />
      <Section8 />
      <Section12 />
      <Section13 />
      <Section14 />
      <Section9 />
      {/* <Section10 /> */}
    </div>
  );
}
